import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../feature-module/router/all_routes";

const ChangeStatusModal = (props: any) => {

  const handleChangeStatus = (response: string) => {
    props.handleChangeStatus(response);
  }

  return (
    <>
      <>
        {/* Delete Modal */}
        <div className="modal fade" id="change_status_modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                {/* <span className="avatar avatar-xl bg-transparent-danger text-danger mb-3">
                  <i className="ti ti-trash-x fs-36" />
                </span> */}
                <h4 className="mb-1">Confirm</h4>
                <p className="mb-3">
                  {props?.title ? props.title : 'Do you want to change status of this item?'}
                </p>
                <div className="d-flex justify-content-center">
                  <Link
                    to="#"
                    className="btn btn-light me-3"
                    data-bs-dismiss="modal"
                    onClick={() => handleChangeStatus('NO')}
                  >
                    Cancel
                  </Link>
                  <Link to="#" data-bs-dismiss="modal" className="btn btn-danger" onClick={() => handleChangeStatus('YES')}>
                    Yes
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
      </>

    </>

  );
};

export default ChangeStatusModal;

